import { gql } from 'graphql-request'

export const M_RESUME_SUBSCRIPTION = gql`
  mutation ResumeSubscription {
    resumeSubscription {
      ... on ResumeResult {
        success
        resumedAt
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
